<div class="wrapper">
  <span class="fa-light fa-face-swear" style="font-size: 75px; color: lightgray"></span>
  <p>The document you are trying to view has either moved, or you don't have access to view it.</p>
  <button *ngIf="!isReview" class="wrapper-button" mat-raised-button color="primary" (click)="close()">Close DocViewer</button>
  <button *ngIf="isReview" class="wrapper-button" mat-raised-button color="primary" (click)="back()">Back to Review Sets</button>
</div>
